import { Column } from '@smartsheet/core-views-api-models';
import { AxiosError } from 'axios';
import { GridRow } from '../../../components/Grid/Grid.interface';
import { ActionsUnion, createAction } from '../../../store';
import {
    FetchReportDataActionParams,
    FetchReportRowActionParams,
    LoadReportJobActionParams,
    PollReportJobActionParams,
    StoreReportDataActionParams,
    StoreReportJobActionParams,
} from './types';

export enum ActionTypes {
    RESET_REPORT_STATE = 'RESET_REPORT_STATE',

    // Report job actions
    LOAD_REPORT_JOB = 'LOAD_REPORT_JOB',
    CANCEL_LOAD_REPORT_JOB = 'CANCEL_LOAD_REPORT_JOB',
    STORE_REPORT_JOB = 'STORE_REPORT_JOB',
    FETCHING_ERROR_REPORT_JOB = 'FETCHING_ERROR_REPORT_JOB',
    POLL_REPORT_JOB = 'POLL_REPORT_JOB',
    CANCEL_POLL_REPORT_JOB = 'CANCEL_POLL_REPORT_JOB',

    // Reports paginated data actions
    FETCH_REPORT_DATA = 'FETCH_REPORT_DATA',
    CANCEL_FETCH_REPORT_DATA = 'CANCEL_FETCH_REPORT_DATA',
    STORE_REPORT_DATA = 'STORE_REPORT_DATA',
    FETCHING_ERROR_REPORT_DATA = 'FETCHING_ERROR_REPORT_DATA',

    // Report row actions
    FETCH_REPORT_ROW = 'FETCH_REPORT_ROW',
    ADD_REPORT_ROW = 'ADD_REPORT_ROW',
    UPDATE_REPORT_ROW = 'UPDATE_REPORT_ROW',
    REMOVE_REPORT_ROW = 'REMOVE_REPORT_ROW',
    FETCHING_ERROR_REPORT_ROW = 'FETCHING_ERROR_REPORT_ROW',

    // Report Columns
    FETCH_REPORT_COLUMNS = 'FETCH_REPORT_COLUMNS',
    CANCEL_FETCH_REPORT_COLUMNS = 'CANCEL_FETCH_REPORT_COLUMNS',
    STORE_REPORT_COLUMNS = 'STORE_REPORT_COLUMNS',
    FETCHING_ERROR_REPORT_COLUMNS = 'FETCHING_ERROR_REPORT_COLUMNS',

    // isReportDataStale actions
    SET_REPORT_DATA_STALE = 'SET_REPORT_DATA_STALE',
    SET_REPORT_DATA_NOT_STALE = 'SET_REPORT_DATA_NOT_STALE',
}

export const Actions = {
    // Action to reset view report state
    resetReportState: () => createAction(ActionTypes.RESET_REPORT_STATE),

    // Report job actions
    loadReportJob: (params: LoadReportJobActionParams) => createAction(ActionTypes.LOAD_REPORT_JOB, params),
    cancelLoadReportJob: () => createAction(ActionTypes.CANCEL_LOAD_REPORT_JOB),
    storeReportJob: (params: StoreReportJobActionParams) => createAction(ActionTypes.STORE_REPORT_JOB, params),
    fetchingErrorReportJob: (error: AxiosError | Error) => createAction(ActionTypes.FETCHING_ERROR_REPORT_JOB, { error }),
    pollReportJob: (params: PollReportJobActionParams) => createAction(ActionTypes.POLL_REPORT_JOB, params),
    cancelPollReportJob: () => createAction(ActionTypes.CANCEL_POLL_REPORT_JOB),

    // Report data actions
    fetchReportData: (params: FetchReportDataActionParams) => createAction(ActionTypes.FETCH_REPORT_DATA, params),
    cancelFetchReportData: () => createAction(ActionTypes.CANCEL_FETCH_REPORT_DATA),
    storeReportData: (params: StoreReportDataActionParams) => createAction(ActionTypes.STORE_REPORT_DATA, params),
    fetchingErrorReportData: (error: AxiosError | Error) => createAction(ActionTypes.FETCHING_ERROR_REPORT_DATA, { error }),

    // Report row actions
    fetchReportRow: (params: FetchReportRowActionParams) => createAction(ActionTypes.FETCH_REPORT_ROW, params),
    addReportRow: (viewId: string, row: GridRow) => createAction(ActionTypes.ADD_REPORT_ROW, { viewId, row }),
    updateReportRow: (viewId: string, row: GridRow) => createAction(ActionTypes.UPDATE_REPORT_ROW, { viewId, row }),
    removeReportRow: (viewId: string, rowId: string) => createAction(ActionTypes.REMOVE_REPORT_ROW, { viewId, rowId }),
    fetchingErrorReportRow: (viewId: string, rowId: string) => createAction(ActionTypes.FETCHING_ERROR_REPORT_ROW, { viewId, rowId }),

    // Report Columns actions
    fetchReportColumns: (viewId: string) => createAction(ActionTypes.FETCH_REPORT_COLUMNS, viewId),
    cancelFetchReportColumns: () => createAction(ActionTypes.CANCEL_FETCH_REPORT_COLUMNS),
    storeReportColumns: (response: Column[]) => createAction(ActionTypes.STORE_REPORT_COLUMNS, response),
    fetchingErrorReportColumns: (error: AxiosError | Error) => createAction(ActionTypes.FETCHING_ERROR_REPORT_COLUMNS, { error }),

    // isReportDataStale actions
    setReportDataStale: () => createAction(ActionTypes.SET_REPORT_DATA_STALE),
    setReportDataNotStale: () => createAction(ActionTypes.SET_REPORT_DATA_NOT_STALE),
};

export type Actions = ActionsUnion<typeof Actions>;
